import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {HashRouter as Router} from 'react-router-dom';
import NavLink from './NavLink';
import {logout} from '../../actions/authorizationAction';
import {selectProject} from "../../actions/projectAction";
import {getAvailablePrinters, setPrinter} from "../../actions/printerAction";
import {connect} from "react-redux";

class TopBar extends Component {

    componentDidMount() {
        this.props.getAvailablePrinters();
        this.printerRefreshInterval = window.setInterval(this.props.getAvailablePrinters, 15000);
    }

    componentWillUnmount() {
        if (this.printerRefreshInterval) {
            window.clearInterval(this.printerRefreshInterval);
        }
    }

    handlePrinterChange = (e) => {
        const availablePrinters = this.props.printer.availablePrinters || [];
        const selectedPrinter = availablePrinters.find((printer) => printer.identifier === e.target.value);
        this.props.setPrinter(selectedPrinter || null);
    };

    render() {
        const { t, username, project, scope, printer, logout, selectProject } = this.props;
        const availablePrinters = printer.availablePrinters || [];
        const selectedPrinterIdentifier = printer.selectedPrinter ? printer.selectedPrinter.identifier : '';

        return (
            <div className="TopBar row border-bottom">
                <Router>
                    <nav className="navbar navbar-static-top">
                        <div className="navbar-header">
                            <ul className="nav navbar-top-links">
                                <li style={{padding: '17px', marginLeft: '8px'}}>
                                    <h2 className="m-n text-navy font-bold">
                                        {scope.small ? scope.small.backendName : ''}
                                    </h2>
                                </li>
                            </ul>
                        </div>
                        <ul className="nav navbar-top-links navbar-right">
                            <li className="topbar-printer">
                                <select className="form-control" name="printer"
                                        value={selectedPrinterIdentifier}
                                        onChange={this.handlePrinterChange}
                                        title="Drucker"
                                        disabled={!availablePrinters.length}>
                                    <option value="">{availablePrinters.length ? 'Kein Drucker' : 'Kein Drucker online'}</option>
                                    {availablePrinters.map((availablePrinter) => (
                                        <option value={availablePrinter.identifier}
                                                key={availablePrinter.identifier}>
                                            {availablePrinter.comment || availablePrinter.identifier}
                                        </option>
                                    ))}
                                </select>
                            </li>
                            <li>
                                <select className="form-control" name="project"
                                        value={project.selectedProject ? project.selectedProject.id : ''}
                                        onChange={(e) => selectProject(e.target.value)}>
                                    {project.availableProjects ? project.availableProjects.map((project) => (
                                        <option value={project.id}
                                                key={project.id}>{project.displayName}</option>
                                    )) : null}
                                </select>
                            </li>
                            <NavLink exact to="/profile" activeClassName="activeLink">
                                <i className="fa fa-user"/>
                                <span className="m-r-sm text-muted welcome-message">{username}</span>
                            </NavLink>
                            <li>
                                <a onClick={logout}>
                                    <i className="fa fa-sign-out"/> {t('default.logout')}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </Router>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        username: state.authorization.username,
        project: state.project,
        printer: state.printer,
        scope: state.scope
    }
};

export default connect(mapStateToProps, {
    logout, selectProject, getAvailablePrinters, setPrinter
})(translate()(TopBar));
